export default "__VITE_ASSET__f297f22c__"